module.exports = "https://static.zego.com/_next/static/images/didi-cf77e62e92199b4628eac95f8d0f30bb.svg";